import { render, staticRenderFns } from "./smartico-widget-navigation-item.vue?vue&type=template&id=6ba96838&scoped=true&"
import script from "./smartico-widget-navigation-item.vue?vue&type=script&lang=ts&"
export * from "./smartico-widget-navigation-item.vue?vue&type=script&lang=ts&"
import style0 from "./smartico-widget-navigation-item.vue?vue&type=style&index=0&id=6ba96838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba96838",
  null
  
)

component.options.__file = "smartico-widget-navigation-item.vue"
export default component.exports